import { useEffect, useMemo, useState } from "react";

function normaliseContainers(containers) {
  if (!containers) {
    return [];
  }
  if (typeof containers === "function") {
    try {
      return normaliseContainers(containers());
    } catch (_err) {
      return [];
    }
  }
  if (Array.isArray(containers)) {
    return containers.filter(Boolean);
  }
  return containers ? [containers] : [];
}

export default function useViewportChangeTick(getContainers, deps = []) {
  const [tick, setTick] = useState(0);
  const depsSignature = useMemo(() => {
    if (!Array.isArray(deps) || deps.length === 0) {
      return "[]";
    }
    try {
      const hasDom =
        typeof window !== "undefined" && typeof window.HTMLElement === "function";
      return JSON.stringify(deps, (_, value) => {
        if (typeof value === "function") {
          return `fn:${value.name || "anonymous"}`;
        }
        if (hasDom && value instanceof window.HTMLElement) {
          return `element:${value.tagName}:${value.id || value.className || ""}`;
        }
        return value;
      });
    } catch (_err) {
      return String(deps);
    }
  }, [deps]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const handler = () => {
      setTick((current) => current + 1);
    };

    window.addEventListener("resize", handler);
    window.addEventListener("orientationchange", handler);

    const nodes = normaliseContainers(getContainers);
    nodes.forEach((node) => {
      try {
        node.addEventListener("scroll", handler, { passive: true });
      } catch (_err) {
        // ignore nodes that do not support addEventListener (e.g., shadow roots)
      }
    });

    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("orientationchange", handler);
      nodes.forEach((node) => {
        try {
          node.removeEventListener("scroll", handler);
        } catch (_err) {
          // ignore
        }
      });
    };
  }, [getContainers, depsSignature]);

  return tick;
}
